var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInput',{ref:"BaseInput",attrs:{"disabled":_vm.disabled,"error-message":_vm.errorMessage,"is-toggleable":_vm.isToggleable,"label":_vm.label,"name":_vm.label,"placeholder":_vm.placeholder,"required":_vm.required,"type":"email","validationtype":"email"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }